import { createContext } from "react";
import { Form } from "modules/forms/hooks/usefetchForm";

type FormContextProps = {
    form: Form,
    onError: (error: Error) => void;
    onSubmit: (data: any) => void;
};

export const FormContext = createContext<FormContextProps>(null);